import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'pioneer-event-button-bar',
  templateUrl: './edit-event-button-bar.component.html'
})
export class EditEventButtonBarComponent {

  @Input()
  eventForm: FormGroup;

  @Input()
  isReadOnly: boolean;

  @Input()
  canBeDeleted: boolean;

  @Output()
  cancel = new EventEmitter();

  @Output()
  save = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  @Output()
  edit = new EventEmitter();

  constructor() { }

  cancelClick() {
    this.cancel.emit();
  }

  saveClick() {
    this.save.emit();
  }

  deleteClick() {
    this.delete.emit();
  }

  editClick() {
    this.edit.emit();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/edit-event-button-bar/edit-event-button-bar.component.ts